<template>
  <div class="flex flex-col min-h-screen">
    <!-- 移动端界面 -->
    <template v-if="isMobileView">
      <!-- 登录页和认证页直接显示 -->
      <template v-if="$route.path==='/login' || $route.path==='/auth'">
        <router-view />
      </template>
      <template v-else>
        <MobileApp />
      </template>
    </template>
    
    <!-- PC端界面 -->
    <template v-else>
      <template v-if="$route.path === '/login' || $route.path === '/auth' || $route.path === '/Sales/SalesReportMobile' || $route.path === '/approval/email-approval'||$route.path === '/approval/email-purchase-list'">
        <router-view />
      </template>
      <template v-else>
        <HeaderBar @toggle-sidebar="toggleSidebar" />
       
        <div class="flex flex-1 bg-gray-100 relative">
          
          <Sidebar :collapsed="sidebarCollapsed" class="z-50" />
          <!-- 主内容区域 -->
          <div class="flex-1 flex flex-col overflow-hidden"
               :class="{
              'ml-16': sidebarCollapsed,
              'ml-60': !sidebarCollapsed,
            }">
              <!-- TabManager 区域 -->
              <div class="flex-shrink-0 pt-16">
                  <TabManager />
              </div>

              <!-- Router-view 内容区域
      <div class="bg-white flex-1 px-1 py-2 overflow-y-auto">
        <keep-alive :include="cachedViews">
          <router-view class="pt-0" />
        </keep-alive>
      </div> -->
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRoute } from "vue-router";
import Sidebar from "./components/AppSidebar.vue";
import HeaderBar from "./components/HeaderBar.vue";
import TabManager from "./components/TabManager.vue";
import MobileApp from "./mobile/MobileApp.vue";

const route = useRoute();
const sidebarCollapsed = ref(false);

// 检测是否为移动设备
const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// 检测是否为移动端视图
const isMobileView = computed(() => {
  // 1. 如果是移动设备，显示移动端界面
  if (isMobileDevice()) {
    return true;
  }
  
  // 2. 如果路由路径包含mobile，显示移动端界面
  if (route.path.includes('/mobile/')) {
    return true;
  }
  
  return false;
});



const toggleSidebar = () => {
  sidebarCollapsed.value = !sidebarCollapsed.value;
};
</script>

<style>
#app {
  font-family: 'Alibaba PuHuiTi', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
